// utils/renderUtils.tsx
import { Button, Link } from "@mui/material";

type LinkConfig = {
  [formId: string]: string[]; // Array of field names to be treated as links
};

export const renderLinkCell = (
  formId: string,
  field: string,
  value: any,
  rowId: number,
  handleView: (id: number) => void,
  linkConfig: LinkConfig,
) => {
  const isLinkField = linkConfig[formId]?.includes(field);

  if (isLinkField) {
    return (
      <span>
        <Button
          variant="outlined"
          sx={{ py: 0.1, px: 2, color: "#1976d2!important" }}
          onClick={() => handleView(rowId)}
        >
          {value}
        </Button>
        {/* <Link
          color="info"
          sx={{
            cursor: "pointer",
            textDecoration: "none",
            //pb: 0.2,
            p: 0.5,
            border: "1px solid #0288d1",
            borderRadius: "4px",
          }}
          onClick={() => handleView(rowId)}
        > */}

        {/* </Link> */}
      </span>
    );
  }

  return <span>{value}</span>;
};
